import { useEffect } from 'react';
import { useApp } from '@/context/AppContext';

/**
 * A custom hook to set the document title for a component.
 * It automatically appends the application name and handles cleanup.
 * @param title The title to set for the page.
 */
export function useDocumentTitle(title: string) {
  const { name } = useApp();

  useEffect(() => {
    // Set the title when the component mounts or the title prop changes.
    document.title = `${title} | ${name}`;

    // Return a cleanup function to reset the title when the component unmounts.
    // This prevents the title from sticking around during navigation.
    return () => {
      document.title = name;
    };
  }, [title, name]); // Only re-run the effect if the title changes.
}
